<template>
    <div class="relative z-10" v-if="$widgetUI=='OLD-UI'">
        <h2 class="text-[16px]">{{ title }}</h2>
        <div>
            <div v-if="selectionGroups.length">
                <template v-for="item in selectionGroups">
                    <v-radio v-model="group"
                             class="w-full"
                             :value="item.code">
                        {{ item.title }}
                    </v-radio>
                </template>
            </div>

            <item-group
                v-for="item in listing"
                :key="item.key"
                :item="item"
                :listingLength="listing.length"
                :withTitle="false"
            />
        </div>
    </div>
    <div class="relative z-10" v-else>
        <div>
            <div v-if="selectionGroups.length" id="top-scroll">
                <template v-for="item in selectionGroups">
                    <v-radio v-model="group"
                             class="w-full my-2"
                             @change="topScroll"
                             :value="item.code">
                        {{ item.title }}
                    </v-radio>
                    <div v-if="group == item.code" class="px-4">
                        <item-group
                            v-for="item in listing"
                            :key="item.key"
                            :item="item"
                            :listingLength="listing.length"
                            :withTitle="false"
                        />
                    </div>
                </template>
            </div>
            <div v-else>
                <item-group
                    v-for="item in listing"
                    :key="item.key"
                    :item="item"
                    :listingLength="listing.length"
                    :withTitle="false"
                />
            </div>

        </div>
    </div>
</template>

<script>
import { EventBus } from "@widget/plugins/event-bus";
import itemGroup from "./selections/item-group";

export default {
    name: "selects",
    components: {
        itemGroup
    },
    computed: {
        audience () {
            return this.$store.getters["widgetData/selectedData"].audience;
        },
        selectionGroups () {
            return this.$store.getters["widgetData/getSelectionGroups"];
        },
        listing () {
            let list = this.$store.getters["widgetData/getAudienceSelections"]("AS");
            if (this.selectionGroups.length) {
                return list.filter(item => item.group === this.group);
            }
            return list;
        },
        title () {
            return this.audience === this.$widgetConfig.b2cBase ? "Demographics" : "Firmographics";
        }
    },
    watch: {
        "selectionGroups.length" () {
            this.setGroup();
        }
    },
    methods: {
        setGroup () {
            let active = this.selectionGroups.find(item => item.active);

            this.group = active ? active.code : null;
        },
        topScroll() {
            // $('.top-scroll').on("click",function(){
            //     $(window).scrollTop(0);
            // });
            var myDiv = document.getElementById('top-scroll');
            myDiv.scrollTop = 0;
            $('.tabs').animate({scrollTop:0}, 'fast');
        }

    },
    created () {
        this.setGroup();
    },
    data () {
        return {
            group: null
        };
    },
    mounted () {
        EventBus.$on("show-select-position", (select) => {
            let storeSelect = this.$store.getters["widgetData/getSelectByCode"](select.code);
            if (storeSelect) {
                this.group = storeSelect.group;
            }
        });
    }
};
</script>
